<template>
  <footer class="mt-20 border-t border-border bg-card">
    <div class="mx-auto max-w-[var(--container)] px-6 py-14">
      <div class="grid gap-8 md:grid-cols-[1.1fr_0.5fr_2.9fr_125px] lg:gap-16">
        <!-- Logo & Description -->
        <div class="max-w-sm">
          <Commerce-Logo />

          <p class="mt-4 text-sm leading-relaxed text-muted-foreground">
            در پی‌جیب می‌توانید مبلغ مورد نظرتان را به سرعت و با کم‌ترین کارمزد، از ایران به اروپا،
            استرالیا، کانادا و ترکیه یا بالعکس، با کمک سایر کاربران پی‌جیب، انتقال دهید.
          </p>
        </div>

        <!-- Links -->
        <section class="items-start">
          <h2 class="mb-4 text-sm font-bold">
            پی‌جیب
          </h2>

          <ul class="flex flex-col items-start gap-2">
            <li>
              <a :href="siteUrl('/terms')"
                class="text-sm text-muted-foreground transition-colors hover:text-primary">
                قوانین و مقررات
              </a>
            </li>

            <li>
              <a :href="siteUrl('/blog/')" target="_blank" rel="noopener noreferrer"
                class="text-sm text-muted-foreground transition-colors hover:text-primary">
                وبلاگ
              </a>
            </li>
            <li>
              <a :href="siteUrl('/about/')" target="_blank" rel="noopener noreferrer"
                class="text-sm text-muted-foreground transition-colors hover:text-primary">
                درباره ما
              </a>
            </li>
          </ul>
        </section>

        <!-- Contact -->
        <section class="items-start">
          <h2 class="mb-4 text-sm font-bold">
            تماس با پی‌جیب
          </h2>

          <ul class="grid items-start gap-1.5">
            <!-- Email -->
            <li class="flex items-center gap-2">
              <img src="/svg/sms.svg" alt="" aria-hidden="true" class="size-4 shrink-0">

              <a href="mailto:info@payjib.com" aria-label="ارسال ایمیل به پی‌جیب"
                class="text-sm text-muted-foreground transition-colors hover:text-primary">
                info@payjib.com
              </a>
            </li>

            <!-- Telegram -->
            <li class="flex items-center gap-2">
              <img src="/svg/Telegram3.svg" alt="" aria-hidden="true" class="size-4 shrink-0">

              <div class="flex items-center gap-1">
                <a dir="ltr" href="https://t.me/+989360950650"
                  aria-label="تماس با پشتیبانی پی‌جیب در تلگرام با شماره ۰۹۳۶۰۹۵۰۶۵۰"
                  class=" text-sm text-muted-foreground transition-colors hover:text-primary">
                  {{ fa('+98 9360950650') }}
                </a>

                <span class="text-muted-foreground">-</span>

                <a dir="ltr" href="https://t.me/+989356049661"
                  aria-label="تماس با پشتیبانی پی‌جیب در تلگرام با شماره ۰۹۳۵۶۰۴۹۶۶۱"
                  class=" text-sm text-muted-foreground transition-colors hover:text-primary">
                  {{ fa('+98 9356049661') }}
                </a>
              </div>
            </li>

            <!-- WhatsApp -->
            <li class="flex items-center gap-2">
              <img src="/svg/whatsapp.svg" alt="" aria-hidden="true" class="size-4 shrink-0">

              <div class="flex items-center gap-1">
                <a dir="ltr" href="https://wa.me/989360950650"
                  aria-label="تماس با پشتیبانی پی‌جیب در واتساپ با شماره ۰۹۳۶۰۹۵۰۶۵۰"
                  class=" text-sm text-muted-foreground transition-colors hover:text-primary">
                  {{ fa(' +98 9360950650') }}
                </a>

                <span class="text-muted-foreground">-</span>

                <a dir="ltr" href="https://wa.me/989356049661"
                  aria-label="تماس با پشتیبانی پی‌جیب در واتساپ با شماره ۰۹۳۵۶۰۴۹۶۶۱"
                  class=" text-sm text-muted-foreground transition-colors hover:text-primary">
                  {{ fa('+98 9356049661') }}
                </a>
              </div>
            </li>

            <!-- Phone -->
            <li class="flex items-center gap-2">
              <img src="/svg/call.svg" alt="" aria-hidden="true" class="size-4 shrink-0">

              <a dir="ltr" href="tel:02122632790" aria-label="تماس تلفنی با پشتیبانی پی‌جیب با شماره ۰۲۱۲۲۶۳۲۷۹۰"
                class="  text-sm text-muted-foreground transition-colors hover:text-primary">
                {{ fa(' 0 21 2263 2790 ') }}
              </a>
            </li>

            <!-- Address -->
            <li class="flex items-start gap-2">
              <img src="/svg/location3.svg" alt="" aria-hidden="true" class="mt-1 size-4 shrink-0">

              <address class="max-w-xl text-sm leading-6 text-muted-foreground">
                استان: تهران - شهرستان: تهران - بخش: مرکزی - شهر: تهران -
                محله حسن آباد - زرگنده - خیابان شهید سیامک شکرآبی -
                خیابان امام زاده - پلاک: ۱۸ - طبقه: ۲
              </address>
            </li>
          </ul>
        </section>

        <!-- Enamad -->
        <section class="flex items-start">
          <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq' alt='' style='cursor:pointer' code='lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'></a>
        </section>
      </div>

      <div
        class="mt-12 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-sm text-muted-foreground sm:flex-row">
        <span>© ۱۴۰۵ / ۲۰۲۶ PayJib — همه حقوق محفوظ است.</span>

        <!-- <button class="transition-colors hover:text-primary" @click="navigateTo('/library')">
          کتابخانه
          کامپوننت‌ها
        </button> -->
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const siteUrl = useSiteUrl()

const router = useRouter()

function navigateTo(path: string) {
  router.push(path)
}
</script>
